import { createSelector } from 'reselect';
import { placedBetBookmakerSelector } from '../common/bet/bet.selectors';
import { betBookmakerSelector } from '../common/bookmakersInfo/bookmakersInfo.selectors';

export const drawerInfoSelector = ({ drawerInfo }) => drawerInfo;

export const drawerBookmakerSelector = createSelector(
    [placedBetBookmakerSelector, betBookmakerSelector],
    (placedBetFeed, betFeed) => placedBetFeed || betFeed,
);



// WEBPACK FOOTER //
// /src/js/drawer/drawer.selectors.js